var map = {
	"./right_01.png": "478e",
	"./right_02.png": "a38a",
	"./right_03.png": "575c",
	"./right_04.png": "69b6",
	"./right_05.png": "4c17",
	"./right_06.png": "3ad3",
	"./right_07.png": "7f34",
	"./right_08.png": "971a",
	"./right_09.png": "0214"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f036";